import styled from "styled-components";
import { colors } from "../../styles/variables";
import { Alert } from "../alerts/Alert";

export const StyledTermsWrapper = styled.div`
  color: ${colors.gray600};
  font-size: 13px;
`;

export const StyledTermsAndConditionsLabel = styled.label`
  display: flex;
  gap: 10px;
`;

export const StyledTermsText = styled.div`
  a {
    color: ${({ theme }) => theme.color.primary};
  }
  margin-bottom: 20px;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;
